// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import ElementUI from 'element-ui';
import './element-variables.scss'
import server from './assets/server.js'
import util from './assets/util.js'
Vue.use(util);
import {
	message
} from '../static/js/resetMessage';
import cal from '../static/js/float.js'
//引入多语言支持
import i18n from '../static/js/i18n'
import ViewUI from 'view-design';
// import '../my-theme/index.less';
import '../static/css/main.css';
import '../static/css/init.scss';
import '../static/css/main.scss';

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import {
	showLoading,
	hideLoading
} from './assets/loading.js';

// vuex全局单例存储
import store from './store/store.js'

// Vue.use(ViewUI)
Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法
});
Vue.prototype.$message = message;

//接口请求
Vue.prototype.$server = server
// Vue.prototype.$payUrl = "https://quxun.cc"
// Vue.prototype.$payUrl = "https://api.zjyunyue.cn"

//浮点数计算
Vue.prototype.$cal = cal

Vue.prototype.$showLoading = showLoading
Vue.prototype.$hideLoading = hideLoading



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n, //挂载i18n
	router,
	store,
	components: {
		App
	},
	template: '<App/>',
	mounted() {
		// WARNING:
		// 前端预渲染，理论上最好每个要预渲染的页面单独安排 render-event 事件
		setTimeout(() => {
			document.dispatchEvent(new Event('render-event'))
		}, 10 * 1000)
	}
})



// WEBPACK FOOTER //
// ./src/main.js